/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useState, useEffect } from "react";
//#endregion
//#region Styles
import { Container } from "./styles";
//#endregion
//#region Components
import SchedulesHeader from "./components/ListHeader/SchedulesHeader";
import HelmetUTP from "components/HelmetUTP/HelmetUTP";
import Preloader from "components/Preloader/Preloader";
import SchedulesSkelleton from "../SchedulesSkelleton/SchedulesSkelleton";
import SchedulesByAllAdvisers from "../SchedulesByAllAdvisers/SchedulesByAllAdvisers";
import SchedulesByAdviser from "../SchedulesByAdviser/SchedulesByAdviser";
import ToastMessage from "components/ToastMessage/ToastMessage";
//#endregion
//#region Services
import { requestGetDateAsPaginated } from "services/appointment/aboutAppoinment";
import { getUserId } from "services/storage/general";
//#endregion
//#region Utils
import { USER_ROLES } from "config/userPermissions";
import useStudentFilter from "./utils/hooks/useStudentFilter";
import { QUANTITY_PER_PAGE } from "views/components/Schedules/utils/constants";
import useSchedules from "./utils/hooks/useSchedules";
import useFilters from "./utils/hooks/useFilters";
import useLoadingRequest from "components/Preloader/utils/hooks/useLoadingRequest";
import useToastMessage from "components/ToastMessage/utils/hooks/useToastMessage";
import useFetchData from "./utils/hooks/useFetchData";
import ScheduleComponentContext from "./utils/context/ScheduleComponentContext";
import BackToView from "components/BackToView/BackToView";
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
//#endregion
const ScheduleComponent = ({
    userRole
}) => {
    const isCoordinator = userRole !== USER_ROLES.ASESORIAS_PSICOLOGO;
    const isBoss = userRole === USER_ROLES.ASESORIAS_JEFECAMPUS;
    //#region States
    const [currentPage, setCurrentPage] = useState(1);
    //#endregion
    const loadingRequest = useLoadingRequest();
    const toastMessage = useToastMessage();
    const filters = useFilters({
        isCoordinator,
        setCurrentPage,
        loadingRequest
    });
    const fetchData = useFetchData({
        loadingRequest,
        filters
    });
    const { 
        setTriggerRequest, 
        fillSchedules, 
        clearSchedules,
        schedulesByAllAdvisers,
        schedulesWeekByAdviser,
        dateFiltered,
        changeReservationAttendance
    } = useSchedules({
        isCoordinator,
        filterFields: filters.value,
        fetchData,
        helpers: {
            loadingRequest,
            toastMessage
        },
        currentPage: {
            value: currentPage,
            set: setCurrentPage
        }
    });
    //#region Effects
    useEffect(() => {
        if (!isCoordinator) 
            filters.change("adviserCode", getUserId());
        fetchData.load();
    }, []);
    useEffect(() => {
        if (!fetchData.loaded) return;
        setTriggerRequest(true);
    }, [fetchData.loaded]);
    //#endregion
    //#region Functions
    const nextOrBackReservationPage = async (lastIdx, next) => {
        loadingRequest.show("Buscando por estudiante...");
        const date = await requestGetDateAsPaginated(filters.value.student.id, lastIdx, next);
        loadingRequest.hide();
        filters.change("date", date);
        setTriggerRequest(true);
    }
    //#endregion
    useStudentFilter({ 
        loadedData: fetchData.loaded,
        filters,
        clearSchedules,
        setTriggerRequest,
        helpers: {
            loadingRequest,
            toastMessage,
        }
    });
    return (
        <ScheduleComponentContext.Provider value={{
            changeReservationAttendance
        }}>
            <HelmetUTP title="Asesorías"/>
            <ToastMessage {...toastMessage.value}/>
            <Preloader {...loadingRequest.value}/>
            <BackToView 
                text="Volver a asesorías"
                to={ABSOLUTE_PATHS.APPOINTMENT}/>
            <Container>
                <SchedulesHeader
                    isCoordinator={isCoordinator}
                    options={fetchData.data}
                    filters={{
                        ...filters,
                        clear: () => filters.clear(clearSchedules, setTriggerRequest)
                    }}
                    setTriggerRequest={setTriggerRequest}
                    isBoss={isBoss}
                />
                {!loadingRequest.value.hidden || !fetchData.loaded
                ? <SchedulesSkelleton quantitiyColumns={QUANTITY_PER_PAGE}/>
                : filters.value.adviserCode 
                    ? <SchedulesByAdviser 
                        filterFields={filters.value}
                        dateFiltered={dateFiltered}
                        reloadData={fillSchedules}
                        setTriggerRequest={setTriggerRequest}
                        isAdviser={!isCoordinator}
                        dataFetch={{
                            ...fetchData.data,
                            schedulesWeekByAdviser
                        }}
                        dataPaginator={{
                            currentPage,
                            setCurrentPage
                        }}
                        changeFilterField={filters.change}
                        nextOrBackReservationPage={nextOrBackReservationPage}
                        isBoss={isBoss}/>
                    : <SchedulesByAllAdvisers 
                        filterFields={filters.value}
                        dateFiltered={dateFiltered}
                        reloadData={fillSchedules}
                        dataFetch={{
                            ...fetchData.data,
                            schedulesByAllAdvisers
                        }}
                        dataPaginator={{
                            currentPage,
                            nextPage: () => {
                                setCurrentPage(currentPage + 1);
                                setTriggerRequest(true);
                            },
                            backPage: () => {
                                setCurrentPage(currentPage - 1);
                                setTriggerRequest(true);
                            },
                        }}
                        isBoss={isBoss}/>}
            </Container>
        </ScheduleComponentContext.Provider>
    );
}

export default ScheduleComponent;
